export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/metronome-icon.svg?9bb8edff54f1c5f654940ac123f2c181";